var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { COOKIE_AUTH } from "../../node_modules/@stellantis-hub/constants/dist/constants.mjs";
import { getCookieByName } from "../../node_modules/@stellantis-hub/utilities/dist/src/functions/cookie.mjs";
import PublicClient from "./PublicClient.mjs";
class AxiosPrivateClient extends PublicClient {
  constructor(config) {
    super(config);
    __publicField(this, "authorization");
    this.authorization = null;
  }
  post(args) {
    return this.submit("post", args);
  }
  get(args) {
    return this.submit("get", args);
  }
  put(args) {
    return this.submit("put", args);
  }
  patch(args) {
    return this.submit("patch", args);
  }
  delete(args) {
    return this.submit("delete", args);
  }
  useBearerToken() {
    this.authorization = getCookieByName(COOKIE_AUTH);
    return this;
  }
  submit(method, options = {
    headers: {},
    endpoint: ""
  }) {
    if (this.authorization) {
      if (!options.headers)
        options.headers = {};
      options.headers.Authorization = this.authorization;
    }
    this.authorization = null;
    return super[method](options);
  }
}
export {
  AxiosPrivateClient as default
};
